import Vue from 'vue';
import Router from 'vue-router';
import VueTheMask from 'vue-the-mask';
import { rtdbPlugin } from 'vuefire';

import App from './App.vue'
import Main from './components/Main.vue';
import Auth from './components/Auth.vue';
import Confirm from './components/Confirm.vue';

Vue.use(rtdbPlugin);
Vue.use(VueTheMask);
Vue.use(Router);
Vue.config.productionTip = false;

let router = new Router({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/auth/:external/:public_key/:callback',
      name: 'Auth',
      component: Auth,
      props: true
    },
    {
      path: '/confirm',
      name: 'Confirm',
      component: Confirm
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});

new Vue({
  router: router,
  render: h => h(App),
  data: {
    loading: false,
    user: null,
    public_key: null,
    callback: null,
    external: null,
    isRedirect: false,
    key: null,
    key_secret: null
  }
}).$mount('#app');
